var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdItemFormBase',{attrs:{"ad-item-entry":_vm.adItemEntry,"save-loading-entry":_vm.editLoading},on:{"ad-item:update":_vm.updateEventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }